package com.mvlikhachev.app.presentation.screen.base

open class BaseScreen(open val route: String)